"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import { Skeleton } from "@/components/ui/skeleton";
import { useTpvBarcodeDetails } from "@/lib/queries/payment";
import { ErrorBanner } from "./error-banner";
import { InstructionContainer } from "./instruction-container";

export const TpvBarcodeInstructions = () => {
  const t = useTranslations("instructions");
  const { data, isPending, isError, refetch } = useTpvBarcodeDetails();

  return (
    <div className="space-y-8">
      {isError && <ErrorBanner refetch={refetch} />}
      <InstructionContainer isError={isError}>
        <p>{t("tpv.intro")}</p>
        <div className="flex flex-col items-center justify-center">
          {!isPending ? (
            data?.qr ? (
              <div className="flex h-60 w-60 items-center justify-center rounded-lg border border-border bg-white">
                <Image
                  src={data.qr}
                  width={256}
                  height={256}
                  alt={t("tpv.qrAlt")}
                  className="h-56 w-56"
                />
              </div>
            ) : (
              data?.barcode && (
                <div className="rounded-lg border border-border bg-white p-2">
                  <Image
                    src={data.barcode}
                    width={256}
                    height={256}
                    alt={t("tpv.barcodeAlt")}
                    className="h-24 w-80"
                  />
                </div>
              )
            )
          ) : (
            <Skeleton className="h-60 w-60" />
          )}
        </div>
        <p className="text-muted text-sm">
          {t.rich("help", {
            email: (chunks) => (
              <a className="text-accent" href="mailto:info@paycode.com.mx">
                {chunks}
              </a>
            ),
            phone: (chunks) => (
              <a className="text-accent" href="tel:+525624870068">
                {chunks}
              </a>
            ),
          })}
        </p>
      </InstructionContainer>
    </div>
  );
};
